// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/~/babel-runtime/~/core-js/library/modules/_to-object.js
// module id = ./node_modules/react-phone-number-input/node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js
// module chunks = 0 1 2